import React, { useState, useRef, useEffect,useContext } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { FieldAttributes, useField, Formik, Form } from "formik";
import {
  EmptyString,
  CanadaProvinces,
  Claims,
  RBAdminEmail,
} from "../util/Common";
import {
  RBTextFieldForForm,
  RBTextField,
  RBSelectForForm,
  RBTextFieldForFormFieldType,
} from "./RBTextField";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";
import { Grid, Typography } from "@material-ui/core";

import LocationOnIcon from "@material-ui/icons/LocationOn";
import { renderTextWithTitleAndChildComponent } from "./TextWithHeader";
import { Spacing } from "../theme/Theme";
import formatService from "../util/FormattingService";
import { RBContext } from "./RBContext";
import { AuthService } from "../api/AuthService";
import debounce from "lodash/debounce";





type RBPlaceSearchForFormProps = {
  name: string; // 👈 add this
  label?: string;
  value: string;
  setFieldValue: (addressObject: any) => void;
  onBlur?: (e: React.FocusEvent<any>) => void; // 👈 add this
}

export const RBPlaceSearchForForm: React.FC<RBPlaceSearchForFormProps> = ({
  name,
  label,
  value,
  setFieldValue,
  onBlur,
}) => {
  const [street, setStreet] = useState(value || "");
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setStreet(value || "");
  }, [value]);

  const fetchSuggestions = async (query: string) => {
    if (!query) {
      setSuggestions([]);
      return;
    }
    setLoading(true);
    try {
      const res:any = await AuthService.getAddressAutocomplete(encodeURIComponent(query));
      const data = res?.data?.data; // axios → no .json()
      setSuggestions(data || []);
    } catch (err) {
      console.error("Error fetching address suggestions:", err);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetch = useRef(
    debounce((query: string) => {
      fetchSuggestions(query);
    }, 500)
  ).current;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setStreet(newValue);
    setFieldValue({ street: newValue });
    debouncedFetch(newValue);
  };
  useEffect(() => {
    return () => {
      // cleanup debounce on unmount
      debouncedFetch.cancel();
    };
  }, [debouncedFetch]);

  const handleSelect = async (suggestion: any) => {
    
    setSuggestions([]);

    try {
      const res:any = await AuthService.getAddressSearch(
        encodeURIComponent(suggestion)
      );
      const details = res?.data?.results?.[0];
    if (!details || !details.address_components) {
      console.error("No address components found");
      return;
    }
     const addressComponents = details.address_components;

    const getComponent = (type: string, useShortName = false) => {
      const comp = addressComponents.find((c: any) =>
        c.types.includes(type)
      );
      return comp ? (useShortName ? comp.short_name : comp.long_name) : '';
    };

    // Prefer sublocality_level_1; fallback to locality
    const sublocality = getComponent("sublocality_level_1");
    const city = sublocality ? sublocality : getComponent("locality");

    const addressObject = {
      street: `${getComponent("street_number")} ${getComponent("route")}`.trim(),
      city,
      postalCode: getComponent("postal_code"),
      province: getComponent("administrative_area_level_1", true),
      country: getComponent("country"),
    };

    console.log("Parsed address:", addressObject);
    setStreet(addressObject.street || "");
    setFieldValue(addressObject);
    } catch (error) {
      console.error("Error fetching address details:", error);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <TextField
        size="small"
        style={{ width: "100%" }}
        name={name}
        value={street}
        onChange={handleChange}
        onBlur={onBlur}
        label={label}
        placeholder="Search address..."
        variant="outlined"
      />

      {loading && <div>Loading...</div>}

      {suggestions.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            zIndex: 10,
            background: "#fff",
            width: "100%",
            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
            borderRadius: 4,
          }}
        >
          {suggestions.map((sugg) => (
            <div
              key={uuidv4()}
              style={{
                padding: 8,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onMouseDown={(e) => {
                e.preventDefault(); // prevents input blur
                handleSelect(sugg);
              }}
            >
              <LocationOnIcon fontSize="small" style={{ marginRight: 8 }} />
              <Typography variant="body2">{sugg}</Typography>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export interface RBPlaceSearchForForm2ValueTypes {
  street: string;
  city: string;
  postalCode: string;
  province: string;
  apartmentSuiteNumber?: string | undefined;
}
interface RBPlaceSearchForForm2Props {
  innerRef?: any;
  onFormChange?: any;
  isProvinceEditable: boolean;
  initialValues: RBPlaceSearchForForm2ValueTypes;
}

const AddressSchema = Yup.object().shape({
  street: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  postalCode: Yup.string().required("Required"),
  province: Yup.string().required("Required"),
});
export const RBPlaceSearchForForm2: React.FC<RBPlaceSearchForForm2Props> = ({
  isProvinceEditable,
  ...props
}) => {
  console.log(
    "isProvinceEditable ",
    isProvinceEditable,
    props.initialValues.province
  );
  const { industryMode,primaryColor,secondaryColor, contactEmail } = useContext(RBContext);

  return (
    <Formik
      initialValues={props.initialValues}
      innerRef={props.innerRef}
      validationSchema={AddressSchema}
      validateOnBlur={true}
      validateOnMount={true}
      validateOnChange={true}
      isInitialValid={AddressSchema.isValidSync(props.initialValues)}
      onSubmit={() => {}}
    >
      {({ values, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
        <div
        // onSubmit={handleSubmit}
        // basically call onFormChange to check if the form is valid
        // onKeyUp={props.onFormChange}
        // onMouseDown={props.onFormChange}
        >
          {renderTextWithTitleAndChildComponent(
            "Street",
            <RBPlaceSearchForForm
              name="street"
              value={values.street}
              setFieldValue={(addressObject: any) => {
                if (
                  isProvinceEditable ||
                  (isProvinceEditable === false &&
                    (addressObject.province === undefined || props.initialValues.province === addressObject.province))
                ) {
                  if ('street' in addressObject) setFieldValue("street", addressObject.street, true);
                  if ('city' in addressObject) setFieldValue("city", addressObject.city, true);
                  if ('postalCode' in addressObject) setFieldValue("postalCode", addressObject.postalCode, true);
                  if ('province' in addressObject) setFieldValue("province", addressObject.province, true);
                } else {
                  console.log("not editable, ", props.initialValues.street);
                  setFieldValue("street", props.initialValues.street, true);
                }
              }}
              onBlur={handleBlur}
            />
          )}
          <div
            style={{
              marginBottom: Spacing.large,
            }}
          />
          {renderTextWithTitleAndChildComponent(
            "Apartment/Suite #",
            <RBTextFieldForForm
              placeholder="Optional"
              name="apartmentSuiteNumber"
              value={values.apartmentSuiteNumber}
              onChange={handleChange}
              onBlur={handleBlur}
              size={"small"}
              style={{
                marginBottom: Spacing.large,
              }}
            />
          )}

          {renderTextWithTitleAndChildComponent(
            "City",
            <RBTextFieldForForm
              //label="City"
              name="city"
              value={values.city}
              onChange={handleChange}
              onBlur={handleBlur}
              size={"small"}
              style={{
                marginBottom: Spacing.large,
              }}
            />
          )}
          {renderTextWithTitleAndChildComponent(
            "Postal Code",
            <RBTextFieldForForm
              //label="Postal Code"
              FieldType={RBTextFieldForFormFieldType.postalCode}
              name="postalCode"
              value={values.postalCode}
              onChange={handleChange}
              onBlur={handleBlur}
              size={"small"}
              style={{
                marginBottom: Spacing.large,
              }}
            />
          )}

          {isProvinceEditable
            ? renderTextWithTitleAndChildComponent(
                "Province",
                <RBSelectForForm
                  name="province"
                  value={values.province}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  mappingValues={CanadaProvinces.map(
                    (province: any) => province.abbr
                  )}
                  style={{
                    marginBottom: Spacing.large,
                  }}
                />
              )
            : renderTextWithTitleAndChildComponent(
                "Province",
                <div
                  style={{
                    marginBottom: Spacing.large,
                  }}
                >
                  <RBTextFieldForForm
                    //label="Postal Code"
                    disabled
                    name="province"
                    value={values.province}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    size={"small"}
                  />
                  {/* <Typography variant={"caption"}>
                    {Claims.changeProvince}
                  </Typography> */}
                  <Typography variant={"caption"}>
                    {Claims.changeProvince + " "}
                    <Typography
                      variant={"inherit"}
                      style={{ display: "inline" }}
                    >
                      {formatService.formatEmail(contactEmail, primaryColor)}
                    </Typography>
                  </Typography>
                </div>
              )}
        </div>
      )}
    </Formik>
  );
};
